<template>
	<div class="search-bar" @mouseover="visible = true" @mouseout="visible = false">
		<el-input v-model="keyWord" :style="inputStyle" @keyup.native="onKeyup"></el-input>
		<i class="el-icon-search" @click="onClickSearch"></i>
	</div>
</template>
<script>
	export default {
		name: 'SearchBar',
		data() {
			return {
				keyWord: '',
				visible: false
			}
		},
		computed: {
			inputStyle() {
				if(this.visible) {
					return {
						width: '250px'
					}
				}else {
					return {
						width: '0px',
						border: 'none',
					}
				}
			}
		},
		methods: {
			onClickSearch() {
				if(this.keyWord) {
					this.visible = false;
					this.$router.push({path: 'search', query: {keyWord: this.keyWord}});
				}
			},
			onKeyup(e) {
				if(e.key == 'Enter') {
					this.onClickSearch();
				}
			}
		}
	}
</script>
<style scoped lang="less">
	.search-bar {
		position: relative;
		padding: 15px;
		min-width: 60px;
	}
	::v-deep {
		.el-input {
			border-radius: 15px;
			overflow: hidden;
			background: transparent;
			border: 1px solid rgba(255, 255, 255, .5);
			transition: 1s;
			input {
				background: transparent;
				border: none;
				line-height: 30px;
				height: 30px;
				padding: 0 40px 0 15px;
				color: rgba(255, 255, 255, .8);
				font-size: 18px;
			}
		}
		.el-icon-search {
			position: absolute;
			right: 20px;
			top: 19px;
			color: rgba(255, 255, 255, .7);
			font-size: 24px;
			font-weight: bold;
			cursor: pointer;
		}
	}
	
</style>